export default "__VITE_ASSET__BN$n6S42__"